import { render, staticRenderFns } from "./GeneratesDetail.vue?vue&type=template&id=31d55a23&scoped=true"
import script from "./GeneratesDetail.vue?vue&type=script&lang=js"
export * from "./GeneratesDetail.vue?vue&type=script&lang=js"
import style0 from "./GeneratesDetail.vue?vue&type=style&index=0&id=31d55a23&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d55a23",
  null
  
)

export default component.exports